<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
        <statistics-card-line hideChart class="mb-base" icon="MapPinIcon" icon-right
          :statistic="summary_obj.totalLocations" statisticTitle="Locations" color="success" />
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
        <statistics-card-line hideChart class="mb-base" icon="HomeIcon" icon-right
          :statistic="summary_obj.totalBuildings" statisticTitle="Buildings" color="success" />
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
        <statistics-card-line hideChart class="mb-base" icon="PhoneIcon" icon-right
          :statistic="summary_obj.totalContacts" statisticTitle="Contacts" color="success" />
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
        <statistics-card-line hideChart class="mb-base" icon="AlertTriangleIcon" icon-right
          :statistic="summary_obj.totalPropertyRiskAssessment" statisticTitle="Property Risk Assessments" />
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
        <statistics-card-line hideChart class="mb-base" icon="AlertTriangleIcon" icon-right
          :statistic="summary_obj.totalCopeAssessment" statisticTitle="COPE Assessments" />
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
        <statistics-card-line hideChart class="mb-base" icon="AlertTriangleIcon" icon-right
          :statistic="summary_obj.totalBrewerySiteInspection" statisticTitle="Brewery Site Inspection" />
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
        <statistics-card-line hideChart class="mb-base" icon="AlertTriangleIcon" icon-right
          :statistic="summary_obj.totalHazardInspection" statisticTitle="Hazard Inspection" />
      </div>
    </div>
    <div id="customer-profile-details" class="vx-row">
      <vx-card>
        <ObjectForm ref="object_form" :object_name="object_name" :method="'update'" :object_id="id"
          @getObjectData="getObjectData" />
      </vx-card>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import ErrorMessages from "@/mixins/ErrorMessages";
const ObjectRepository = RepositoryFactory.get('object')
const AdminRepository = RepositoryFactory.get('admin')
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import ObjectForm from "@/components/shared/Forms/ObjectForm.vue"

export default {
  name: "TenantDetailsView",
  data() {
    return {
      tenant_details: {},
      id: this.$route.params.id,
      object_name: 'account',
      object_data: {},
      form: {},
      lookup_options: {},
      summary_obj: {
        totalAccounts: 0,
        totalBrewerySiteInspection: 0,
        totalBuildings: 0,
        totalContacts: 0,
        totalPropertyRiskAssessment: 0,
        totalLocations: 0,
        totalCopeAssessment: 0,
        totalHazardInspection: 0
      },
    }
  },
  components: {
    'v-select': vSelect,
    flatPickr,
    StatisticsCardLine,
    ObjectForm
  },
  async mounted() {
    await this.fetchDashboardSummary()
  },
  mixins: [ErrorMessages],
  methods: {
    async getObjectData() {
    },
    async onClickSubmitForm() {
      this.$vs.loading()
      try {
        await ObjectRepository.updateObject(this.object_name, this.form._id, this.form)
        this.showSuccessMessage('Company updated successfully')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async fetchDashboardSummary() {
      const { data } = (await AdminRepository.getDashboardSummary(this.id)).data
      this.summary_obj = data
    }
  },
}
</script>

<style scoped></style>
